import React, { lazy, Fragment } from 'react';
import ParentStyled from './style';
import { loadStyle, loadPageConfig } from 'globalutils/fmUtils';

let Styled = loadStyle(ParentStyled, 'pages/web/PrivacyPolicy');

const PrivacyPolicy = ({ pageTitle }) => {
  const config = loadPageConfig();
  return config.privacyPolicy.map((item) => {
    const { name, title } = item;
    const Component = lazy(() => import(`@/${name}`));
    return (
      <Fragment key={title}>
        <Component pageTitle={pageTitle} Styled={Styled} />
      </Fragment>
    );
  });
};

export default PrivacyPolicy;
